<template>
  <div class="outer-wrapper">
  </div>
</template>

<script>
export default {
  name: 'ReceiveResetPassword',
  components: {},
  async created() {
    this.$router.push('/');
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
